export interface BarDatum {
  label: string;
  value: number;
}

interface BarChartProps {
  data: BarDatum[];
  height?: number;
}

export function BarChart({ data, height = 160 }: BarChartProps) {
  const max = Math.max(...data.map((d) => d.value), 1);

  return (
    <div className="bar-chart" style={{ height }}>
      {data.map((d, i) => {
        const empty = d.value === 0;
        const pct = empty ? 0 : Math.max(8, (d.value / max) * 100);
        return (
          <div key={i} className="bar-chart__col">
            <div className={`bar-chart__val${empty ? ' is-empty' : ''}`}>{d.value}</div>
            <div className="bar-chart__area">
              <div
                className={`bar-chart__bar${empty ? ' is-empty' : ''}`}
                style={{ height: `${pct}%` }}
              />
            </div>
            <div className="bar-chart__label">{d.label}</div>
          </div>
        );
      })}
    </div>
  );
}

export default BarChart;
